import React, { useState, useEffect } from "react";
import Header from "../../Components/Header";
import Seo from "../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import { fetchProfile, verifyAadharWithOtpV2, generateAadharOtpV2, verifyAadharWithOtpResendV2 } from "../../Services/ApiTestService/aadharTestService";
import { InputWithLabel, Button } from "../../Components/Tags/Tags";
import Loader from "../../Loader";
import { AadharData } from "../TestAPI/Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { FaDownload } from 'react-icons/fa';


const MandateReport = () => {
    const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    mobile: "",
    email: "",
    name: "",
    status: "",
  });

  const [data] = useState([
    {
      id: 1,
      customerName: "Test Name",
      email: "test@example.com",
      mobile: "9876543210",
      status: "Processed",
      instalmentAmount: "₹2,500",
      totalInstalments: 12,
      videoLock: "Locked",
      device: "Disable",
    },
    {
      id: 2,
      customerName: "Kumar",
      email: "Kr@example.com",
      mobile: "9123456780",
      status: "Cancelled",
      instalmentAmount: "₹3,000",
      totalInstalments: 10,
      videoLock: "Unlocked",
      device: "Enable",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    // console.log("Searching with filters:", filters);
  };

  return (
     <>
            <Seo />
            {isLoading && <Loader />}
            <Header heading="Mandate Report" />
    <div className="p-2 md:p-2 bg-gray-50 min-h-screen">
      <h2 className="text-xl md:text-2xl font-semibold text-center text-blue-700 mb-6">
       Mandate Report
      </h2>

      {/* 🔍 Filter Section */}
      <form
        onSubmit={handleSearch}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 bg-white shadow-md p-2 rounded-xl"
      >
        <div>
          <label className="block text-sm font-medium text-gray-700">From Date</label>
          <input
            type="date"
            name="fromDate"
            value={filters.fromDate}
            onChange={handleChange}
            className="w-full border border-blue-400 rounded-md px-3 py-2 outline-none"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">To Date</label>
          <input
            type="date"
            name="toDate"
            value={filters.toDate}
            onChange={handleChange}
            className="w-full border border-blue-400 rounded-md px-3 py-2 outline-none"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Mobile No</label>
          <input
            type="text"
            name="mobile"
            placeholder="Enter mobile number"
            value={filters.mobile}
            onChange={handleChange}
            className="w-full border border-blue-400 rounded-md px-3 py-2 outline-none"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            placeholder="Enter email"
            value={filters.email}
            onChange={handleChange}
            className="w-full border border-blue-400 rounded-md px-3 py-2 outline-none"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Name</label>
          <input
            type="text"
            name="name"
            placeholder="Enter name"
            value={filters.name}
            onChange={handleChange}
            className="w-full border border-blue-400 rounded-md px-3 py-2 outline-none"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Status</label>
          <select
            name="status"
            value={filters.status}
            onChange={handleChange}
            className="w-full border border-blue-400 rounded-md px-3 py-2 outline-none"
          >
            <option value="">Select Status</option>
            <option value="Processed">Processed</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>

        <div className="flex items-end justify-center sm:col-span-2 lg:col-span-3">
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md shadow-md"
          >
            Search
          </button>
        </div>
      </form>

      {/* 📊 Table Section */}
      <div className="mt-6 overflow-x-auto bg-white shadow-md rounded-xl">
        <table className="min-w-full text-sm text-gray-700">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th className="p-2">SRN</th>
              <th className="p-2">Customer Name</th>
              <th className="p-2">Email</th>
              <th className="p-2">Mobile</th>
              <th className="p-2">Status</th>
              <th className="p-2">Instalment Amount</th>
              <th className="p-2">Total No. of Instalments</th>
              <th className="p-2">Action</th>
              <th className="p-2">View Inst</th>
              <th className="p-2">Device Lock</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, i) => (
              <tr
                key={item.id}
                className={`text-center ${
                  i % 2 === 0 ? "bg-gray-50" : "bg-gray-100"
                }`}
              >
                <td className="p-2">{item.id}</td>
                <td className="p-2">{item.customerName}</td>
                <td className="p-2">{item.email}</td>
                <td className="p-2">{item.mobile}</td>
                <td
                  className={`p-2 font-semibold ${
                    item.status === "Processed" ? "text-green-600" : "text-red-600"
                  }`}
                >
                  {item.status}
                </td>
                <td className="p-2">{item.instalmentAmount}</td>
                <td className="p-2">{item.totalInstalments}</td>
                <td className="p-2 flex justify-center gap-2">
                  <button className="bg-red-500 hover:bg-red-600 text-white px-1 py-0 rounded-md">
                    Cancel
                  </button>
                  {/* <button className="bg-blue-500 hover:bg-blue-600 text-white px-1 py-0 rounded-md">
                    View
                  </button>
                  <button className="bg-gray-500 hover:bg-gray-600 text-white px-1 py-0 rounded-md">
                    Delete
                  </button> */}
                </td>
                <td className="p-1">
                     <button className="bg-blue-500 hover:bg-blue-600 text-white px-1 py-0 rounded-md">
                    View
                  </button>

                </td>
                <td className="p-2">{item.device}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    </>
  );
};

export default MandateReport;
